import { Location } from '@angular/common';
import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { App } from '@capacitor/app';

@Injectable()
export class BackButtonService {
    private backFunction: (() => void) | null = null;

    constructor(
        private ngZone: NgZone,
        private router: Router,
        private location: Location
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.backFunction = null;
            }
        });

        App.addListener('backButton', ({ canGoBack }) =>
            this.ngZone.run(() => {
                if (this.backFunction) {
                    this.backFunction();
                } else if (canGoBack) {
                    this.location.back();
                } else {
                    void App.exitApp();
                }
            })
        );
    }

    get canNavigateBack(): boolean {
        return !['/', '/customers', '/inloggen'].includes(this.router.url.split('?')[0]);
    }

    navigateBack(): void {
        if (this.backFunction) {
            this.backFunction();
        } else {
            this.location.back();
        }
    }

    setBackbuttonAction(action: (() => void) | null): void {
        this.backFunction = action;
    }

    getBackbuttonAction(): (() => void) | null {
        return this.backFunction;
    }
}
